// extracted by mini-css-extract-plugin
module.exports = {"roomContainer":"room_type_roomContainer__3BlKg","ratesList":"room_type_ratesList__2OmXz"};